import React, { useState, useEffect } from "react";
import { Input } from "@/components/ui/input";

export default function CurrencyInput({ value, onChange, className, ...props }) {
  const [displayValue, setDisplayValue] = useState("");

  useEffect(() => {
    setDisplayValue(formatarMoeda(value));
  }, [value]);

  const formatarMoeda = (valor) => {
    if (!valor && valor !== 0) return "";
    
    const numero = parseFloat(valor);
    if (isNaN(numero)) return "";
    
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(numero);
  };

  const limparValor = (str) => {
    // Remove tudo exceto números
    return str.replace(/[^\d]/g, '');
  };

  const handleChange = (e) => {
    const input = e.target.value;
    
    // Se está apagando tudo, retorna 0
    if (!input || input === 'R$' || input === 'R$ ' || input.trim() === '') {
      onChange(0);
      setDisplayValue("");
      return;
    }
    
    // Remove todos os caracteres não numéricos
    const apenasNumeros = limparValor(input);
    
    if (apenasNumeros === '') {
      onChange(0);
      setDisplayValue("");
      return;
    }
    
    // Converte para número (centavos)
    const valorEmCentavos = parseInt(apenasNumeros, 10);
    const valorEmReais = valorEmCentavos / 100;
    
    // Formata para exibição
    const valorFormatado = formatarMoeda(valorEmReais);
    setDisplayValue(valorFormatado);
    
    // Chama o onChange com o valor numérico
    onChange(valorEmReais);
  };

  const handleFocus = (e) => {
    // Seleciona todo o conteúdo ao focar
    setTimeout(() => {
      e.target.select();
    }, 0);
  };

  const handleBlur = () => {
    // Força a formatação completa ao sair do campo
    if (value || value === 0) {
      const numeroLimpo = parseFloat(value);
      if (!isNaN(numeroLimpo)) {
        setDisplayValue(formatarMoeda(numeroLimpo));
      }
    }
  };

  const handleKeyDown = (e) => {
    // Permite: backspace, delete, tab, escape, enter, setas
    if ([8, 9, 27, 13, 46, 37, 38, 39, 40].indexOf(e.keyCode) !== -1 ||
        // Permite: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
        (e.keyCode === 65 && e.ctrlKey === true) ||
        (e.keyCode === 67 && e.ctrlKey === true) ||
        (e.keyCode === 86 && e.ctrlKey === true) ||
        (e.keyCode === 88 && e.ctrlKey === true)) {
      return;
    }
    
    // Bloqueia qualquer tecla que não seja número
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) &&
        (e.keyCode < 96 || e.keyCode > 105)) {
      e.preventDefault();
    }
  };

  return (
    <Input
      type="text"
      value={displayValue}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      className={`text-right font-mono ${className}`}
      placeholder="R$ 0,00"
      {...props}
    />
  );
}